import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ForgotPasswordState } from "../../../Interfaces/ReduxSliceInterface";

const initialState: ForgotPasswordState = {
  devCode: "",
  email: "",
};

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    setForgotPasswordData: (
      state,
      action: PayloadAction<{ devCode: string; email: string }>
    ) => {
      state.devCode = action.payload.devCode;
      state.email = action.payload.email;
    },
    clearForgotPasswordData: (state) => {
      state.devCode = "";
      state.email = "";
    },
  },
});

export const { setForgotPasswordData, clearForgotPasswordData } =
  forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;

